import API from './api.js'

export default {
    async getOrders(notEvaluated, notInvoiced, partialyInvoiced) {
        try {
            let q = ''
            if (notEvaluated){
                q = 'notEvaluated=true'
            }
            if (notInvoiced){
                q += q.length > 0 ? '&notInvoiced=true' : 'notInvoiced=true'
            }
            if (partialyInvoiced){
                q += q.length > 0 ? '&partialyInvoiced=true' : 'partialyInvoiced=true'
            }

            let response = await API.HTTPS.get('/orders' + (q.length > 0 ? '?' + q : ''))

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async getOrder(id) {
        try {
            let response = await API.HTTPS.get('/orders/' + id)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async getOrderPdfs(id) {
        try {
            let response = await API.HTTPS.get('/orders/' + id + '/existingpdfs')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async unlockOrder(id) {
        try {
            let response = await API.HTTPS.get('/orders/' + id + '/lock?locked=false')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async lockOrder(id) {
        try {
            let response = await API.HTTPS.get('/orders/' + id + '/lock?locked=true')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async postOrder(data) {
        try {
            let response = await API.HTTPS.post('/orders', data)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async putOrder(id, data) {
        try {
            let response = await API.HTTPS.put('/orders/' + id, data)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async createPdf(id) {
        try {
            let response = await API.HTTPS.get('/orders/' + id + '/pdf')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async createProtocol(id) {
        try {
            let response = await API.HTTPS.get('/orders/' + id + '/acceptanceprotocol')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async sendOrder(id) {
        try {
            let response = await API.HTTPS.get('/orders/' + id + '/send')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async deleteOrder(id) {
        try {
            let response = await API.HTTPS.delete('/orders/' + id)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    }
}